import './brokerRiskIndicatorForAlternativeFunds.scss';
import React from 'react';
import PropTypes from 'prop-types';
const { FormattedText } = require('core/i18n').i18n;

import { OKLink } from 'commonsComponents/OKLink';
import RiskNumbers from '../brokerRiskIndicator/riskNumbers';
import FormattedTextWithComponents from 'components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents';

import complexityIcon from 'assets/icons/complexity_icon.svg';
import lockIcon from 'assets/icons/icon-candado.svg';


const BrokerRiskIndicatorForAlternativeFunds = ({textContent, links}) => {
    const linksOfComponent = links.length && links.map((link) => {
        const linkName = link.replace(/(^\w+:|^)\/\//, '');
        return (<OKLink key={link} to={link} target="_blank">{linkName}</OKLink>);
    });

    return (
        <div className="broker-alt-funds-risk-indicator-liquidity">
            <div className="broker-alt-funds-risk-indicator-liquidity__container">
                <div className="broker-alt-funds-risk-indicator-container__title">
                    <FormattedText value="brokerAlternativeFunds-riskIndicator_title" />
                </div>
                <div className="broker-alt-funds-risk-indicator-container__content-liquidity">
                    <div className="broker-alt-funds-risk-indicator-risk-numbers">
                        <RiskNumbers riskValue={0} liquidity={true} />
                        <div className="broker-alt-funds-risk-indicator-risk-numbers__risk-text">
                            <FormattedText value="brokerAlternativeFunds-riskIndicator_minorRiskLabel" />
                            <FormattedText value="brokerAlternativeFunds-riskIndicator_majorRiskLabel" />
                        </div>
                    </div>
                    <div className="broker-alt-funds-risk-indicator-risk-content__liquidity">
                        <FormattedTextWithComponents value={textContent} injectedComponents={linksOfComponent} />
                    </div>
                </div>
            </div>
            <div>
                <p className="broker-alt-funds-risk-indicator__plans-header-box-title">
                    <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerTitle1" />
                </p>
                <div className="broker-alt-funds-risk-indicator__plans-header-box-content">
                    <div className="broker-alt-funds-risk-indicator__plans-header-box-content-icons">
                        <img
                            className="broker-alt-funds-risk-indicator__warrants-header-box-content-complexity-icon"
                            src={complexityIcon}
                            alt="complexity icon"
                        />
                    </div>
                    <div className="broker-alt-funds-risk-indicator__plans-header-box-content-text">
                        <p>
                            <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent1" />
                        </p>
                    </div>
                </div>
                <div className='broker-alt-funds-risk-indicator__plans-header-box-liquidity'>
                    <p className="broker-alt-funds-risk-indicator__plans-header-box-title">
                        <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerTitle2" />
                    </p>
                    <div className="broker-alt-funds-risk-indicator__plans-header-box-content">
                        <div className="broker-alt-funds-risk-indicator__plans-header-box-content-icons">
                            <img  src={lockIcon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                            <img  src={lockIcon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                        </div>
                        <div className="broker-alt-funds-risk-indicator__plans-header-box-content-text">
                            <p>
                                <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent2" />
                            </p>
                        </div>
                    </div>
                    <div className="broker-alt-funds-risk-indicator__plans-header-box-content">
                        <div className="broker-alt-funds-risk-indicator__plans-header-box-content-icons">
                            <img  src={lockIcon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                            <img  src={lockIcon} alt="candado_icon" className="icon-candado broker-risk-information-box-type-seven__warning-icon"/>
                        </div>
                        <div className="broker-alt-funds-risk-indicator__plans-header-box-content-text">
                            <p>
                                <FormattedText value="brokerAdvancedSearch-brokerAdvancedSearch_alternativeFundsDisclaimerContent3" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

BrokerRiskIndicatorForAlternativeFunds.propTypes = {
    minorRiskKey: PropTypes.string,
    majorRiskKey: PropTypes.string,
    textContent: PropTypes.string,
    links: PropTypes.array
};

export default BrokerRiskIndicatorForAlternativeFunds;